<!-- display-desktop-08 preview — a display ad in the right rail of a desktop
     publisher page, on the same stand-in page as the other desktop placements:
     a serif wordmark, a nav row with the site tools opposite it, then the
     article. The article keeps its column on the left and the ad sits in a rail
     beside it. The unit is the framed form Google serves for a square slot: the
     uploaded creative is not shown sharp at all — it is blown up and blurred to
     fill the slot, and a white card floats on it carrying the advertiser mark,
     the headline, the description and a filled call-to-action button. -->
<app-desktop-frame>
  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- The site account button, tight against the top of the window. -->
    <div class="da-account d-flex justify-content-end">
      <i class="bi bi-person-circle" aria-hidden="true"></i>
    </div>

    <!-- The publisher wordmark. A stand-in logo, so it is set as text. -->
    <div class="da-wordmark">website</div>

    <!-- Site nav on the left, site tools on the right. -->
    <div class="da-nav d-flex flex-row align-items-start">
      <span
        *ngFor="let item of navItems"
        class="da-nav-item placeholder"
        aria-hidden="true"
      ></span>

      <div class="da-tools d-flex flex-row align-items-center ms-auto">
        <i class="bi bi-search" aria-hidden="true"></i>
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
        <i class="bi bi-share" aria-hidden="true"></i>
        <i class="bi bi-envelope" aria-hidden="true"></i>
        <i class="bi bi-rss" aria-hidden="true"></i>
      </div>
    </div>

    <!-- The article column and the ad rail beside it. -->
    <div class="da-content d-flex flex-row">
      <!-- The article the ad sits beside, and the lead image the window cuts
           off. Same skeleton as the placements that run above the article, just
           in a narrower share of the page. -->
      <div class="da-article">
        <div class="da-bars d-flex flex-column">
          <span
            *ngFor="let bar of bodyBars; let last = last"
            class="da-bar placeholder"
            [class.da-bar-short]="last"
            aria-hidden="true"
          ></span>
        </div>

        <div class="da-block" aria-hidden="true"></div>
      </div>

      <!-- START: Real ad -->
      <div class="da-ad">
        <!-- The creative is the backdrop rather than a picture of its own: the
             mock shows no sharp edge of it anywhere, only a blurred wash behind
             and around the card. Decorative, so it carries no alt text — the
             headline and description below say what the ad is. -->
        <!-- Not dimension-routed, unlike the other placements: this wash is the only
             thing the creative is used for here, and a blurred ground has no format —
             any of the four upload sizes reads the same once it is blurred. -->
        <img class="da-backdrop" [src]="data.image" alt="" aria-hidden="true" />

        <!-- Chrome the network draws over the unit, so it is decorative here.
             It gets its own white tile, as the mock has it, so it stays
             legible whatever the upload puts behind it. -->
        <span class="da-adchoices d-flex align-items-center justify-content-center">
          <i class="bi bi-info-circle" aria-hidden="true"></i>
        </span>

        <div class="da-card">
          <!-- GenSingleImagePreviewData carries no logo field, so the mark is
               the Valamar asset rather than an authored one, the same
               compromise the other placements make. -->
          <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
          <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>

          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
            {{ data.headlines[0] || "Your headline appears here" }}
          </a>

          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <!-- Unlike the rail placements with a round arrow, this unit gives the
               call to action a label of its own, so the authored text is what
               the button reads. -->
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta">
            {{ data.ctaText || "Your call to action" }}
          </a>
        </div>
      </div>
      <!-- END: Real ad -->
    </div>
  </div>
  <!-- END: Publisher page -->
</app-desktop-frame>
